import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import AdminPanel from "@/components/AdminPanel";
import { useBranding } from "@/hooks/useBranding";

function App() {
  const brandName = useBranding();
  useEffect(() => { document.title = brandName; }, [brandName]);
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<AdminPanel />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
